import { CLEAN_APOSTAS, RECEIVE_APOSTAS, RETRIEVED_APOSTA, CLOSE_APOSTA_DETAIL } from "./suasapostasActions";

const SUASAPOSTAS_INITIAL_STATE = { 
    arrJogo:undefined
}

export default (state = SUASAPOSTAS_INITIAL_STATE, action) => {
    switch (action.type){
        case CLEAN_APOSTAS:
            return {
                ...state,
                arrJogo: undefined
            }
        case RECEIVE_APOSTAS:
            return {
                ...state,
                arrJogo: action.payload.arrJogo
            }
        case RETRIEVED_APOSTA:
            return {
                ...state,
                apostaAtual: action.payload,
                showAposta: true,
            }
        case CLOSE_APOSTA_DETAIL:
            return {
                ...state,
                apostaAtual: null,
                showAposta: false,
            }            
      default:
          return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/relatorios/suasapostasReducer.js